//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalDeposit',
  data() {
    return {
      url: 'https://cashier-dev.bet777.be/ver2/cashier/index?key_sport=MTYzMDY0NCRXdmRJNmJwaFFxZTRjRGpZVkpwTnlOOTdLam5BU1l1UEg2M1hpeDVTJGJldFM%3D',
      submitting: false,
      amount: '10',
      selectedPaymentMethod: null,
      paymentMethods: [
        { name: 'Credit card', icon: 'la-cc-visa', code: 'cc' },
        { name: 'Crypto', icon: 'la-monero', code: 'crypto' },
        { name: 'Apple Pay', icon: 'la-apple-pay', code: 'apple-pay' },
        { name: 'PayPal', icon: 'la-paypal', code: 'paypal' }
      ]
    }
  },
  mounted() {
    this.selectedPaymentMethod = _.first(this.paymentMethods).code
  },
  methods: {
    beforeOpen(event) {
      console.log('Opening...', _.get(event, 'params.url'))
      this.url = _.get(event, 'params.url');
      let height = 546;
      let width = 500
      var left = (screen.width/2)-(width/2);
      var top = (screen.height/2)-(height/2);
      //window.open(this.url, 'Cashier', 'width='+width+',height='+height+',toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=no,left='+left+',top='+top);
      window.dispatchEvent(new Event('resize'));
    },
    close() {
      this.$modal.hide('modal-deposit')
    },
    select(paymentMethod) {
      this.selectedPaymentMethod = paymentMethod
    },
    async submit() {
      this.submitting = true
      try {
        const response = await this.$axios.$post('/api/transactions/deposit', {
          amount: this.amount
        })
        this.$notyf.success('Successfully deposited!')
        this.$root.$emit('update_balance')
        this.$modal.hide('modal-deposit')
      } catch (e) {
        this.$notyf.error('Something went wrong!')
      }
      this.submitting = false
    }
  }
}
